module.exports = __webpack_public_path__ + "img/question3.52477ec7.svg";